{
  "privacy": {
    "consentTitle": "Privacy & analytics",
    "consentBody": "We use analytics to improve the product and crash reports to find errors. Choose what you want to allow. You can change this anytime in Account → Privacy.",
    "analyticsLabel": "Usage analytics",
    "analyticsDesc": "Mixpanel/Google Analytics for product and funnel metrics. If you decline, we only count funnel steps as anonymous aggregates (no identifiers, no Mixpanel/GA).",
    "crashLabel": "Crash reports",
    "crashDesc": "Sentry for technical errors, stability and diagnostics.",
    "acceptAll": "Accept all",
    "rejectAll": "Reject all",
    "saveChoices": "Save choices",
    "settingsItemTitle": "Privacy",
    "settingsItemDesc": "Analytics, crash reports and opt-out",
    "accountSection": "Account",
    "sectionTitle": "Data consent",
    "sectionBody": "Control product analytics and crash reports separately. When turned off, new calls stop being sent.",
    "savePreferences": "Save preferences",
    "saved": "Privacy preferences saved."
  },
  "errorBoundary": {
    "title": "Something went wrong",
    "message": "An unexpected error occurred. We have been notified. You can try again or contact support.",
    "retry": "Try again",
    "contactSupport": "Contact support"
  },
  "loginTitle": "Login",
  "emailPlaceholder": "Email",
  "passwordPlaceholder": "Password",
  "loginButton": "Login",
  "signupPrompt": "Don't have an account?",
  "signupLink": "Sign up",
  "loginError": "Please enter email and password.",
  "loginFailed": "Email or password is incorrect.",
  "loginSuccess": "Welcome, {{email}}!",
  "validation": {
    "required": "This field is required",
    "invalidEmail": "Invalid email",
    "passwordMinLength": "Password must be at least 8 characters long"
  },
  "alerts": {
    "movementDetected": "You are moving but not in driving mode. Please start driving mode.",
    "stationaryDetected": "You have been stationary for a while. Consider stopping driving mode.",
    "reopenAppBeforeStartingTracking": "Reopen the app before starting driving or session tracking.",
    "locationPermissionDenied": "Location permission not granted. Click to try again.",
    "locationPermissionRequired": "Location Permission Required",
    "locationPermissionRequiredMessage": "The app needs access to your location to function properly. Please grant location permission.",
    "locationPermissionRetryMessage": "If you just changed location permissions in your browser settings, please refresh the page to continue.",
    "locationSettingsInvalid": "Location Unavailable",
    "locationSettingsInvalidMessage": "Could not get your location. Please make sure GPS is enabled and location mode is set to high accuracy.",
    "locationTrackingDegraded": "Automatic location tracking is temporarily unavailable. Your work session remains available.",
    "openDeviceSettings": "Open Settings",
    "locationSettingsManualFallback": "Could not get your location. Enable GPS in settings or enter your location manually.",
    "tryAgain": "Try Again",
    "refreshPage": "Refresh Page",
    "alert": "Alert",
    "confirm": "Confirm"
  },
  "register": {
    "choiceTitle": "Register",
    "driverButton": "Driver",
    "ownerButton": "Fleet Owner",
    "registerTitle": "Register",
    "registerDriverTitle": "Driver Registration",
    "registerOwnerTitle": "Register as Fleet Owner",
    "next": "Next",
    "back": "Back",
    "submitButton": "Submit",
    "loginInformation": "Login Information",
    "identification": "Identification",
    "driverDetails": "Driver Details",
    "companyInformation": "Company Information",
    "registrationSuccessTitle": "Successfully registered!",
    "registrationSuccessMessage": "Please confirm your email to complete registration.",
    "okButton": "OK"
  },
  "chooseRolePrompt": "Choose how to register: Driver or Fleet Owner. If you are both, register as Owner.",
  "nifPlaceholder": "NIF",
  "addressPlaceholder": "Address",
  "licenseTypePlaceholder": "License Type",
  "licenseNumberPlaceholder": "CMTVDE",
  "workStartDatePlaceholder": "Work Start Date",
  "dobPlaceholder": "Date of Birth",
  "dateOfBirthPlaceholder": "Date of Birth",
  "dualRoleMessage": "If you are both Owner and Driver, register as Owner.",
  "submitButton": "Submit",
  "fullNamePlaceholder": "Full Name",
  "phoneNumberPlaceholder": "Phone Number",
  "companyNamePlaceholder": "Company Name",
  "companyEmailPlaceholder": "Company Email",
  "nipcPlaceholder": "NIPC",
  "certidaoPermanentePlaceholder": "Permanent Certificate",
  "numeroLicencaPlaceholder": "CMTVDE",
  "registerSuccess": "Registration successful!",
  "registerFailed": "Registration failed.",
  "goBack": "Go Back",
  "userInformation": "User Information",
  "forgotPassword": "Forgot your password?",
  "invalidEmail": "Invalid email.",
  "invalidPassword": "Password must be at least 8 characters.",
  "requiredField": "Required field.",
  "emailVerifiedSuccessfully": "Email verified successfully!",
  "ok": "OK",
  "drivingTimeToday": "Today's Driving",
  "startDriving": "Start Driving",
  "drivingStates": {
    "starting": "Starting...",
    "stopping": "Stopping...",
    "endingSession": "Ending session...",
    "processing": "Processing..."
  },
  "startSession": "Start Session",
  "close": "Close",
  "waitingForActivation": "Pending Activation",
  "pendingSelfPayHint": "Don't want to wait? You can activate your own licence right now.",
  "pendingSelfPayCta": "I pay for my own licence",
  "pendingEmploymentMessage": "Please wait for company {{nipc}} to activate your profile.",
  "addAnotherCompany": "Add Another Company",
  "addCompanyInfo": "Add Fleet Company Information",
  "addVehicleInfo": "Add Vehicle",
  "registrationNumber": "Registration Number",
  "make": "Make",
  "model": "Model",
  "fuelType": {
    "gasolina": "Petrol",
    "gasoleo": "Diesel",
    "bifuel": "Bi-fuel",
    "hibrido": "Hybrid",
    "eletrico": "Electric"
  },
  "endSession": "End Session",
  "stopDriving": "Stop Driving",
  "selectVehicle": "Select a Vehicle",
  "errorStartingSession": "Error starting session",
  "errorEndingSession": "Error ending session",
  "errorStartingDriving": "Error starting driving",
  "errorStoppingDriving": "Error stopping driving",
  "odometer": "Odometer",
  "odometerStart": "Initial Odometer",
  "odometerEnd": "Final Odometer",
  "lastOdometerReading": "Last Reading",
  "latestOdometerReading": "Last Reading",
  "odometerRequired": "Odometer reading is required when ending a session",
  "hours": "hours",
  "optional": "Optional",
  "edited": "Edited",
  "date": "Date",
  "time": "Time",
  "dateTime": "Date & Time",
  "observationsRequiredWhenEdited": "Required when edited",
  "eventLabels": {
    "session_in": "Session start",
    "session_out": "Session end",
    "drive_in": "Drive start",
    "drive_out": "Drive end"
  },
  "weeklyDrivingReport": "Weekly Reports",
  "companyDetails": "Company Details",
  "name": "Name",
  "phoneNumber": "Phone Number",
  "dateOfBirth": "Date of Birth",
  "nif": "NIF",
  "address": "Address",
  "licenseNumber": "CMTVDE",
  "companyName": "Company Name",
  "nipc": "NIPC",
  "companyEmail": "Company Email",
  "totalWeek": "Week Total",
  "loading": {
    "default": "Loading...",
    "checkingData": "Checking data...",
    "loadingVehicles": "Loading vehicles...",
    "loadingData": "Loading data...",
    "userInformation": "Loading user information..."
  },
  "driverDashboard": {
    "noVehicleAssignedTitle": "No vehicle assigned",
    "noVehicleAssignedRecoveryMessage": "You are in Driver mode but do not have a vehicle assigned yet. You can continue driver setup or switch back to the Owner profile.",
    "noVehicleAssignedDriverOnlyMessage": "Your company has not assigned a vehicle yet. You can continue vehicle setup now or return later.",
    "continueVehicleSetup": "Continue vehicle setup",
    "redirectingToVehicleSetup": "Redirecting to vehicle setup..."
  },
  "noReport": "No reports available",
  "notProvided": "Not provided",
  "noLocation": "No location",
  "reports": "Reports",
  "nextWeek": "Next Week",
  "previousWeek": "Previous Week",
  "exportPDF": "Export PDF",
  "errorExportingPDF": "Error exporting PDF",
  "home": "Home",
  "logout": "Logout",
  "settings": "Settings",
  "switchToDriver": "Switch to Driver",
  "switchToOwner": "Switch to Owner",
  "receiveNotifications": "Receive Notifications",
  "stopTimeThreshold": "Stop Time (minutes)",
  "distanceThreshold": "Alert Distance (meters)",
  "save": "Save",
  "preferencesSaved": "Preferences saved!",
  "errorSavingPreferences": "Error saving preferences.",
  "sessionInactive": "Session inactive",
  "sessionActive": "Session active",
  "driving": "Driving",
  "locationExplanation": "We need location access at all times to monitor your driving and send alerts when necessary.",
  "foregroundLocation": "Foreground Location",
  "backgroundLocation": "Background Location",
  "notificationsTitle": "Notifications",
  "notificationsDescription": "To receive alerts and important information",
  "foregroundLocationDescription": "To show your current location on the map",
  "backgroundLocationDescription": "To continue tracking even when the app is closed",
  "enabled": "Enabled",
  "enable": "Enable",
  "goToSettings": "Go to Settings",
  "permissionDenied": "Permission Denied",
  "permissionExplanation": "We need {{type}} permission to monitor your location and send real-time notifications.",
  "vehicleRegistration": "Vehicle Registration",
  "drivingTime": "Driving Time",
  "availabilityTime": "Availability Time",
  "restTime": "Rest Time",
  "logs": "Logs",
  "observations": "Observations",
  "totalWeekDriving": "Week Total (Driving)",
  "totalWeekAvailability": "Week Total (Availability)",
  "totalWeekRest": "Week Total (Rest)",
  "eventType": "Event Type",
  "start": "Start",
  "end": "End",
  "startLocation": "Start Location",
  "endLocation": "End Location",
  "total": "Total",
  "available": "Available",
  "notificationSettings": "Notification Settings",
  "permissions": "Permissions",
  "status": "Status",
  "cancel": "Cancel",
  "currentWeek": "Current Week",
  "selectWeek": "Select Week",
  "selectedWeek": "Selected Week",
  "selectDate": "Select Date",
  "select": "Select",
  "clickDateToSelectWeek": "Click any date to select that week",
  "email": "Email",
  "daily-report": "Daily Report",
  "dailyDrivingReport": "Daily Report",
  "success": "Success",
  "error": "Error",
  "resetPasswordTitle": "Reset Password",
  "resetPasswordDescription": "Enter your email address and we'll send you instructions to reset your password.",
  "resetPasswordButton": "Send Reset Link",
  "changePasswordButton": "Change Password",
  "resetPasswordSuccess": "If an account exists with this email, you will receive password reset instructions.",
  "resetPasswordError": "An error occurred while requesting password reset. Please try again.",
  "resetPasswordFailed": "Could not send password reset email.",
  "currentPasswordPlaceholder": "Current password",
  "newPasswordPlaceholder": "New Password",
  "confirmPasswordPlaceholder": "Confirm New Password",
  "passwordsDontMatch": "Passwords do not match",
  "passwordResetSuccess": "Your password has been reset successfully. Please login with your new password.",
  "passwordChangeSuccess": "Your password has been changed successfully.",
  "passwordResetError": "An error occurred while resetting your password. The link may have expired.",
  "allFieldsRequired": "Please fill in all fields",
  "networkError": "Network error. Please try again.",
  "enterNewPassword": "Enter your new password below.",
  "invalidResetLink": "Invalid password reset link. Please request a new one.",
  "emailRequired": "Please enter your email address",
  "passwordRequired": "Password is required",
  "passwordTooShort": "Password must be at least 8 characters",
  "passwordMustContainUppercase": "Password must contain at least one uppercase letter",
  "passwordMustContainLowercase": "Password must contain at least one lowercase letter",
  "passwordMustContainNumber": "Password must contain at least one number",
  "passwordValidationError": "Password validation error",
  "fullNameRequired": "Full name is required",
  "phoneNumberRequired": "Phone number is required",
  "companyNameRequired": "Company name is required",
  "nipcRequired": "NIPC is required",
  "nipcInvalidLength": "NIPC must be 9 digits",
  "certidaoPermanenteRequired": "Permanent certificate is required",
  "certidaoPermanenteInvalidLength": "Permanent certificate must be 12 characters",
  "numeroLicencaRequired": "License number is required",
  "numeroLicencaInvalidLength": "License number must be 5 characters",
  "unexpectedError": "An unexpected error occurred",
  "nifRequired": "NIF is required",
  "nifInvalidLength": "NIF must be 9 digits",
  "addressRequired": "Address is required",
  "licenseNumberRequired": "License number is required",
  "workStartDateRequired": "Work start date is required",
  "dateOfBirthRequired": "Date of birth is required",
  "licenseNumberOperadorPlaceholder": "Operator License Number",
  "numeroLicencaOperadorRequired": "Operator license number is required",
  "numeroLicencaOperadorInvalidLength": "Operator license number must have up to 10 digits before the slash",
  "numeroLicencaOperadorInvalidFormat": "Invalid operator license format. Use N.../YYYY.",
  "licenseNumberInvalidFormat": "Invalid CMTVDE format. Use NNNNNNNN+/YYYY.",
  "countries": {
    "portugal": "Portugal",
    "afghanistan": "Afghanistan",
    "albania": "Albania",
    "algeria": "Algeria",
    "andorra": "Andorra",
    "angola": "Angola",
    "antiguaAndBarbuda": "Antigua and Barbuda",
    "argentina": "Argentina",
    "armenia": "Armenia",
    "australia": "Australia",
    "austria": "Austria",
    "azerbaijan": "Azerbaijan",
    "bahamas": "Bahamas",
    "bahrain": "Bahrain",
    "bangladesh": "Bangladesh",
    "barbados": "Barbados",
    "belarus": "Belarus",
    "belgium": "Belgium",
    "belize": "Belize",
    "benin": "Benin",
    "bhutan": "Bhutan",
    "bolivia": "Bolivia",
    "bosniaAndHerzegovina": "Bosnia and Herzegovina",
    "botswana": "Botswana",
    "brazil": "Brazil",
    "brunei": "Brunei",
    "bulgaria": "Bulgaria",
    "burkinaFaso": "Burkina Faso",
    "burundi": "Burundi",
    "cambodia": "Cambodia",
    "cameroon": "Cameroon",
    "canada": "Canada",
    "capeVerde": "Cape Verde",
    "centralAfricanRepublic": "Central African Republic",
    "chad": "Chad",
    "chile": "Chile",
    "china": "China",
    "colombia": "Colombia",
    "comoros": "Comoros",
    "congo": "Congo",
    "costaRica": "Costa Rica",
    "croatia": "Croatia",
    "cuba": "Cuba",
    "cyprus": "Cyprus",
    "czechRepublic": "Czech Republic",
    "denmark": "Denmark",
    "djibouti": "Djibouti",
    "dominica": "Dominica",
    "dominicanRepublic": "Dominican Republic",
    "ecuador": "Ecuador",
    "egypt": "Egypt",
    "elSalvador": "El Salvador",
    "equatorialGuinea": "Equatorial Guinea",
    "eritrea": "Eritrea",
    "estonia": "Estonia",
    "ethiopia": "Ethiopia",
    "fiji": "Fiji",
    "finland": "Finland",
    "france": "France",
    "gabon": "Gabon",
    "gambia": "Gambia",
    "georgia": "Georgia",
    "germany": "Germany",
    "ghana": "Ghana",
    "greece": "Greece",
    "grenada": "Grenada",
    "guatemala": "Guatemala",
    "guinea": "Guinea",
    "guineaBissau": "Guinea-Bissau",
    "guyana": "Guyana",
    "haiti": "Haiti",
    "honduras": "Honduras",
    "hongKong": "Hong Kong",
    "hungary": "Hungary",
    "iceland": "Iceland",
    "india": "India",
    "indonesia": "Indonesia",
    "iran": "Iran",
    "iraq": "Iraq",
    "ireland": "Ireland",
    "israel": "Israel",
    "italy": "Italy",
    "jamaica": "Jamaica",
    "japan": "Japan",
    "jordan": "Jordan",
    "kazakhstan": "Kazakhstan",
    "kenya": "Kenya",
    "kiribati": "Kiribati",
    "koreaSouth": "South Korea",
    "kuwait": "Kuwait",
    "kyrgyzstan": "Kyrgyzstan",
    "laos": "Laos",
    "latvia": "Latvia",
    "lebanon": "Lebanon",
    "lesotho": "Lesotho",
    "liberia": "Liberia",
    "libya": "Libya",
    "liechtenstein": "Liechtenstein",
    "lithuania": "Lithuania",
    "luxembourg": "Luxembourg",
    "macau": "Macau",
    "macedonia": "Macedonia",
    "madagascar": "Madagascar",
    "malawi": "Malawi",
    "malaysia": "Malaysia",
    "maldives": "Maldives",
    "mali": "Mali",
    "malta": "Malta",
    "marshallIslands": "Marshall Islands",
    "mauritania": "Mauritania",
    "mauritius": "Mauritius",
    "mexico": "Mexico",
    "micronesia": "Micronesia",
    "moldova": "Moldova",
    "monaco": "Monaco",
    "mongolia": "Mongolia",
    "montenegro": "Montenegro",
    "morocco": "Morocco",
    "mozambique": "Mozambique",
    "myanmar": "Myanmar",
    "namibia": "Namibia",
    "nauru": "Nauru",
    "nepal": "Nepal",
    "netherlands": "Netherlands",
    "newZealand": "New Zealand",
    "nicaragua": "Nicaragua",
    "niger": "Niger",
    "nigeria": "Nigeria",
    "norway": "Norway",
    "oman": "Oman",
    "pakistan": "Pakistan",
    "palau": "Palau",
    "palestine": "Palestine",
    "panama": "Panama",
    "papuaNewGuinea": "Papua New Guinea",
    "paraguay": "Paraguay",
    "peru": "Peru",
    "philippines": "Philippines",
    "poland": "Poland",
    "qatar": "Qatar",
    "romania": "Romania",
    "russia": "Russia",
    "rwanda": "Rwanda",
    "saudiArabia": "Saudi Arabia",
    "senegal": "Senegal",
    "serbia": "Serbia",
    "seychelles": "Seychelles",
    "sierraLeone": "Sierra Leone",
    "singapore": "Singapore",
    "slovakia": "Slovakia",
    "slovenia": "Slovenia",
    "solomonIslands": "Solomon Islands",
    "somalia": "Somalia",
    "southAfrica": "South Africa",
    "southSudan": "South Sudan",
    "spain": "Spain",
    "sriLanka": "Sri Lanka",
    "sudan": "Sudan",
    "suriname": "Suriname",
    "swaziland": "Swaziland",
    "sweden": "Sweden",
    "switzerland": "Switzerland",
    "syria": "Syria",
    "taiwan": "Taiwan",
    "tajikistan": "Tajikistan",
    "tanzania": "Tanzania",
    "thailand": "Thailand",
    "timorLeste": "Timor-Leste",
    "togo": "Togo",
    "tonga": "Tonga",
    "trinidadAndTobago": "Trinidad and Tobago",
    "tunisia": "Tunisia",
    "turkey": "Turkey",
    "turkmenistan": "Turkmenistan",
    "tuvalu": "Tuvalu",
    "uganda": "Uganda",
    "ukraine": "Ukraine",
    "unitedArabEmirates": "United Arab Emirates",
    "unitedKingdom": "United Kingdom",
    "unitedStates": "United States",
    "uruguay": "Uruguay",
    "uzbekistan": "Uzbekistan",
    "vanuatu": "Vanuatu",
    "vaticanCity": "Vatican City",
    "venezuela": "Venezuela",
    "vietnam": "Vietnam",
    "yemen": "Yemen",
    "zambia": "Zambia",
    "zimbabwe": "Zimbabwe"
  },
  "searchCountry": "Search country",
  "phoneNumberInvalid": "Phone number must be at least 8 digits",
  "locationBackgroundPermissionTitle": "Location (Background)",
  "locationBackgroundPermissionDescription": "To continue tracking even when the app is closed",
  "locationBackgroundPermissionImportant": "Important: To receive notifications when you're stopped at the same location for a while, you need to select 'Allow all the time' in your device's location settings.",
  "comingSoon": "Coming Soon",
  "ownerRegistrationContact": "Interested in registering as an owner? Contact us at:",
  "userData": {
    "title": "User Data",
    "languageTitle": "Language Settings",
    "currentLanguage": "Current Language",
    "profileTitle": "My Profile",
    "vehicleTitle": "My Vehicle",
    "companyTransferTitle": "Request Company Transfer",
    "editProfile": "Edit Profile",
    "editVehicle": "Edit Vehicle",
    "requestTransfer": "Request Transfer",
    "currentCompany": "Current Company",
    "notAvailable": "N/A",
    "noVehicleData": "No vehicle information available.",
    "fullName": "Full Name",
    "email": "Email",
    "phoneNumber": "Phone Number",
    "dateOfBirth": "Date of Birth",
    "nif": "NIF",
    "address": "Address",
    "licenseType": "License Type",
    "licenseNumber": "License Number",
    "workStartDate": "Work Start Date",
    "notificationPreferences": "Notification Preferences",
    "receiveNotifications": "Receive Notifications",
    "stopTimeThreshold": "Stop Time Threshold",
    "distanceThreshold": "Distance Threshold",
    "languageChanged": "Language changed successfully.",
    "languageChangeError": "Failed to change language.",
    "loadError": "Failed to load data.",
    "updateError": "Failed to update profile.",
    "profileUpdateSuccess": "Profile updated successfully.",
    "emailChangeSuccess": "Email updated. Please check your new email to verify. You will be logged out.",
    "changeEmailTitle": "Change Email",
    "changeEmailHint": "You'll need to confirm your new email before it becomes active.",
    "emailEditHint": "To change your email, use the \"Change Email\" section below.",
    "newEmail": "New email",
    "requestEmailChange": "Request email change",
    "resendConfirmation": "Resend confirmation email",
    "resendInSeconds": "Resend in {{seconds}}s",
    "emailChangePendingMessage": "We sent a confirmation link to {{email}}. Click it to finish changing your email.",
    "emailChangeRequestSuccess": "If the request is valid, we've sent a confirmation email to the new address.",
    "emailChangeRateLimited": "Please wait a moment before trying again.",
    "emailChangeError": "Failed to request email change.",
    "emailInvalid": "Enter a valid email address.",
    "vehicleLoadError": "Could not load vehicle details.",
    "vehicleUpdateSuccess": "Vehicle details updated.",
    "vehicleUpdateError": "Failed to update vehicle details.",
    "vehicleIdMissing": "Vehicle ID is missing, cannot update.",
    "transferSuccess": "Company transfer requested.",
    "transferError": "Failed to request company transfer.",
    "invalidNipc": "Invalid NIPC. Must be a 9-digit number starting with 5.",
    "contactMethodRequired": "Please provide either an email or phone number for the new company.",
    "newCompanyName": "New Company Name",
    "newCompanyNipc": "New Company NIPC",
    "companyEmail": "Company Email (Optional)",
    "companyPhone": "Company Phone (Optional)",
    "transferReason": "Reason for Transfer",
    "submitRequest": "Submit Request",
    "editVehicleTitle": "Edit Vehicle Details",
    "requestTransferTitle": "Request Company Transfer"
  },
  "units": {
    "min": "min",
    "m": "m"
  },
  "vehicle": {
    "year": "Year",
    "licensePlate": "License Plate",
    "make": "Make",
    "model": "Model",
    "fuelType": "Fuel Type",
    "selectFuelType": "Select fuel type"
  },
  "fuelTypes": {
    "gasolina": "Gasoline",
    "gasoleo": "Diesel",
    "bifuel": "Bi-fuel",
    "hibrido": "Hybrid",
    "eletrico": "Electric"
  },
  "download": {
    "downloadTitle": "Download AllDrivers",
    "downloadDescription": "Get early access to the AllDrivers app before it hits the Play Store",
    "feature1": "TVDE Time Tracking",
    "feature2": "Location Tracking",
    "feature3": "Digital Logbook",
    "downloadButton": "Download APK",
    "version": "Version",
    "downloadNote": "This is a pre-release version. The official version will be available soon on the Google Play Store."
  },
  "companyInfo": {
    "menu": "Company",
    "title": "Company",
    "emailChangeNotice": "Changing the company email may require verification."
  },
  "failedToLoadCompany": "Failed to load company info",
  "failedToUpdateCompany": "Failed to update company",
  "companyUpdated": "Company details updated successfully",
  "emailUpdated": "Email updated",
  "emailNeedsVerification": "Please check your inbox to verify your new company email.",
  "completeDriverProfile": {
    "menu": "Complete Driver Profile",
    "modalTitle": "Become a driver",
    "boundaryNotice": "This will use one of the company's free licences.",
    "errorTitle": "Could not save profile",
    "genericError": "We couldn't save the profile. Try again.",
    "networkError": "We couldn't reach the server. Try again.",
    "submit": "Save profile",
    "becomeDriverSubmit": "Become a driver"
  },
  "selectCountry": "Select Country",
  "loginInformation": "Login Information",
  "identification": "Identification",
  "confirmPasswordRequired": "Please confirm your password",
  "passwordsDoNotMatch": "Passwords do not match",
  "phoneNumberTooLong": "Phone number is too long",
  "emailChangeWarning": "Changing your email will require verification. A confirmation email will be sent to the new address.",
  "manageDrivers": {
    "title": "Manage Drivers",
    "search": "Search",
    "noDriversFound": "No drivers found.",
    "resend": "Resend",
    "resendSuccess": "Invitation resent successfully",
    "resendError": "Error resending invitation",
    "invitationSent": "Invitation sent successfully",
    "status": {
      "active": "active",
      "inactive": "inactive",
      "pending": "pending"
    }
  },
  "manageVehicles": "Manage Vehicles",
  "manageLicenses": "Manage Licenses",
  "drivers": {
    "menu": "Drivers"
  },
  "vehicles": {
    "menu": "Vehicles"
  },
  "ownerDashboard": {
    "activeDrivers": "Active Drivers",
    "totalLicenses": "Total Licenses",
    "availableLicenses": "Available",
    "hoursLicenses": "Hours Licenses",
    "availableHoursLicenses": "Available Hours",
    "gpsLicenses": "GPS Licenses",
    "availableGpsLicenses": "Available GPS",
    "gpsActiveDevices": "GPS Active Devices",
    "activeVsLicenses": "Active vs Licenses",
    "capacityTitle": "Corporate capacity",
    "licensesAndDrivers": "Licenses and drivers",
    "companyLicensesLabel": "Company licenses",
    "ofLabel": "of",
    "usedLabel": "used",
    "activeDriversLabel": "Active drivers",
    "activeDriversUnavailable": "unavailable",
    "totalLabel": "total",
    "companyLabel": "company",
    "reservedByInvitationLabel": "Reserved by invitation",
    "payerToConfirmLabel": "Payer to confirm",
    "capacityUsedPurchased": "Company-paid seats used / purchased",
    "capacitySelfPay": "Self-pay",
    "capacityPurchased": "Purchased",
    "capacitySeatsInUse": "Corporate seats in use",
    "capacityNeedsReview": "Needs review (included above)",
    "capacityReserved": "Reserved",
    "capacityAvailable": "Available",
    "capacitySelfPayAssociations": "Self-pay associations",
    "capacitySelfPayZeroSeats": "Self-pay associations use no company seats; coverage is shown per driver.",
    "capacityUnavailable": "Capacity unavailable",
    "activeDriversShort": "Active",
    "licensesShort": "Licenses",
    "activatedVsDeactivated": "Activated vs Deactivated",
    "activatedShort": "Activated",
    "deactivatedShort": "Deactivated",
    "gpsDevicesOffline": "Devices Offline",
    "inviteDriver": "Invite Driver",
    "inviteDriverDesc": "Send invitation to new drivers",
    "buyLicenses": "Buy Licenses",
    "buyLicensesDesc": "Purchase additional driver licenses",
    "buyHoursLicenses": "Buy Hours Licenses",
    "buyHoursLicensesDesc": "Purchase additional driver hour tracking licenses",
    "buyGpsLicenses": "Buy GPS Licenses",
    "buyGpsLicensesDesc": "Purchase GPS device tracking licenses",
    "companyStats": "Company Statistics",
    "currentlyDriving": "Currently Driving",
    "avgDriveTime": "Avg. Drive Time",
    "avgDistance": "Avg. Distance",
    "perDriver": "per driver",
    "perDay": "per day",
    "driverLocations": "Driver Locations",
    "driverLocationsDesc": "Real-time location of your drivers",
    "driverStatus": "Driver Status",
    "totalDrivers": "Total Drivers",
    "inviteSuccess": "Invitation sent successfully",
    "choosePlan": "Choose your plan",
    "save10Percent": "Save 10% with the annual plan",
    "14daystrial": "7-day free trial",
    "startTrial": "Start 7-day trial",
    "buyNow": "Buy Now",
    "trialDaysLeft": "Trial Days Left",
    "days": "days",
    "loadingLicenses": "Loading license information...",
    "loadingDashboard": "Loading dashboard...",
    "checkingLicenses": "Checking licenses...",
    "chartOnWeb": "Chart on web",
    "addDriver": "Add Driver",
    "addDriverDesc": "Add an existing driver to your company",
    "becomeDriver": "I also drive",
    "becomeDriverDesc": "Save your driver profile for later onboarding",
    "becomeDriverTitle": "Do you also want to drive?",
    "becomeDriverCta": "Become a driver",
    "seatsInUseTitle": "All licences are in use",
    "buyLicenseCta": "Buy licence",
    "completeDriverProfile": "Save profile",
    "average": "average",
    "dailyActiveUsers": "Daily active users",
    "highOdometer": "Highest odometer",
    "invitations": "Invitation activity",
    "invitationSubsetNote": "Invitations are grouped by creation window; the 7-day group is included in the 30-day group.",
    "invitation7Days": "Last 7 days",
    "invitation30Days": "Last 30 days",
    "invitationSent": "Sent",
    "invitationAccepted": "Accepted",
    "invitationExpired": "Expired",
    "invitationUnavailable": "Invitation data unavailable",
    "monthlyActiveUsers": "Monthly active users",
    "noData": "No data available",
    "sentAcceptedExpired": "sent/accepted/expired"
  },
  "buyLicense": {
    "title": "Buy Licenses",
    "description": "Purchase additional driver licenses for your company",
    "currentLicenses": "Current Licenses",
    "availableLicenses": "Available Licenses",
    "activeDrivers": "Active Drivers",
    "selectPlan": "Select a subscription plan",
    "selectQuantity": "How many licenses do you need?",
    "quantity": "Number of licenses",
    "summary": "Order Summary",
    "plan": "Plan",
    "licenses": "Licenses",
    "total": "Total",
    "setupFee": "Setup fee",
    "once": "once",
    "monthlyAmount": "Monthly",
    "totalFirstInvoice": "Total (1st invoice)",
    "purchase": "Purchase",
    "processing": "Processing...",
    "errorFetchingPlans": "Error fetching subscription plans",
    "noPlanSelected": "Please select a plan first",
    "invalidQuantity": "Invalid number of licenses",
    "stripeInitError": "Failed to initialize payment system",
    "subscriptionError": "Failed to create subscription",
    "noData": "No data received from server",
    "noPaymentIntent": "No payment information received",
    "purchaseFailed": "Payment process failed. Please try again.",
    "portalOpenFailed": "Failed to open billing portal",
    "paymentCancelled": "Payment was cancelled",
    "webPaymentError": "Failed to complete payment",
    "pricePerLicense": "Price per License",
    "totalPrice": "Total Price",
    "paymentMethod": "Payment Method",
    "creditCard": "Credit Card",
    "confirmPurchase": "Confirm Purchase",
    "cancel": "Cancel",
    "success": "Purchase Successful",
    "successMessage": "Your licenses have been added to your account",
    "error": "Purchase Failed",
    "errorMessage": "There was an error processing your purchase. Please try again.",
    "insufficientFunds": "Insufficient Funds",
    "insufficientFundsMessage": "Your payment method has insufficient funds for this purchase.",
    "invalidCard": "Invalid Card",
    "invalidCardMessage": "The provided card information is invalid. Please check and try again.",
    "networkError": "Network Error",
    "networkErrorMessage": "There was a problem connecting to the payment service. Please try again.",
    "quantityRequired": "Please select the number of licenses to purchase",
    "paymentMethodRequired": "Please select a payment method",
    "processingPayment": "Processing payment...",
    "paymentSuccess": "Payment successful!",
    "paymentError": "Payment failed. Please try again.",
    "licenseAdded": "Licenses added to your account",
    "licenseAddedMessage": "Your new licenses have been added to your account successfully.",
    "refreshAccount": "Refreshing your account...",
    "refreshError": "Error refreshing account. Please refresh the page manually.",
    "pay": "Pay Now",
    "annualSavings": "Save 10% with the annual plan",
    "manageInStripe": "Manage in Stripe",
    "purchaseSuccessRefreshError": "License purchase successful, but there was an error updating your account. Please refresh the page.",
    "purchaseSuccessUpdated": "License purchase successful! Your account has been updated.",
    "purchaseSuccessUpdating": "License purchase successful! Updating your account..."
  },
  "interval": {
    "month": "month",
    "year": "year"
  },
  "inviteForm": {
    "title": "Invite Driver",
    "licensePayerTitle": "Who pays for this invitation?",
    "licensePayerCompany": "Company pays",
    "licensePayerSelf": "Driver pays",
    "licensePayerRequired": "Select who will pay before sending the invitation.",
    "companyLicenseLoading": "Checking available company licenses...",
    "companyLicenseUnavailable": "Company license availability could not be confirmed. Choose driver pays or try again.",
    "companyLicenseError": "Company license availability could not be checked. Choose driver pays or try again.",
    "email": "Email",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "fullName": "Full Name (Optional)",
    "fullNameRequired": "Full name is required",
    "phoneNumber": "Phone Number (Optional)",
    "phoneNumberRequired": "Phone number is required",
    "phoneNumberInvalid": "Invalid phone number format",
    "nif": "NIF (Optional)",
    "nifRequired": "NIF is required",
    "nifInvalid": "NIF must be 9 digits",
    "address": "Address (Optional)",
    "addressRequired": "Address is required",
    "licenseNumber": "CMTVDE Number (Optional)",
    "licenseNumberRequired": "CMTVDE number is required",
    "licenseNumberInvalid": "Invalid CMTVDE format. Use NNNNNNNN+/YYYY.",
    "workStartDate": "Work Start Date (Optional)",
    "workStartDateRequired": "Work start date is required",
    "dateOfBirth": "Date of Birth (Optional)",
    "dateOfBirthRequired": "Date of birth is required",
    "submit": "Send Invitation",
    "cancel": "Cancel",
    "back": "Back",
    "optional": "(Optional)",
    "required": "(Required)",
    "licenseType": "License Type (Optional)",
    "licenseTypeRequired": "License type is required",
    "licenseExpiry": "License Expiry Date (Optional)",
    "licenseExpiryRequired": "License expiry date is required",
    "licenseCountry": "License Country (Optional)",
    "licenseCountryRequired": "License country is required",
    "optionalFieldsExplanation": "You can add more information about the driver (optional)",
    "addMoreInfo": "Add driver details (name, phone, address, etc.)",
    "noLicensesAvailable": "No licenses available to invite drivers.",
    "buyLicensesLink": "Click here to buy more licenses",
    "expirationInfo": "This invitation will expire in 7 days."
  },
  "common": {
    "cancel": "Cancel",
    "invite": "Invite",
    "add": "Add",
    "buy": "Buy",
    "knowMore": "Know More",
    "all": "All",
    "status": "Status",
    "success": "Success",
    "error": "Error",
    "loading": "Loading...",
    "now": "Now",
    "minutesAgo": "{{count}}m ago",
    "hoursAgo": "{{count}}h ago",
    "daysAgo": "{{count}}d ago",
    "remove": "Remove",
    "retry": "Try again"
  },
  "transfer": {
    "vehicleTitle": "Transfer Vehicle",
    "vehicleDescription": "Select the company to transfer this vehicle to. All driver assignments will be removed.",
    "driverTitle": "Transfer Driver",
    "driverDescription": "Select the company to transfer this driver to. All vehicle assignments will be removed.",
    "selectCompany": "Please select a target company",
    "error": "Error transferring",
    "errorLoadingCompanies": "Error loading companies",
    "noOtherCompanies": "You need at least one other company to transfer to.",
    "transferButton": "Transfer",
    "alsoTransferVehicles": "Also transfer {{count}} related vehicles",
    "alsoTransferDrivers": "Also transfer {{count}} related drivers"
  },
  "inviteDriverModal": {
    "title": "Invite Driver",
    "optionalFieldsExplanation": "Fill in optional fields like full name, phone number, address, license number, and dates to provide more details. You can skip these for now.",
    "addMoreInfo": "Add more info",
    "sendButton": "Send",
    "activateDialogTitle": "Activate Driver",
    "activateDialogMessage": "This driver is in your fleet but inactive. Do you want to activate?",
    "activate": "Activate",
    "activateError": "Could not activate this driver. Please try again."
  },
  "invalidInvitationLink": "Invalid invitation link",
  "invitationNotFound": "Invitation not found or expired.",
  "acceptInvitation": "Accept Invitation",
  "invitationTitle": "Invitation from {{company}}",
  "invitationLoginMessage": "Please log in to accept the invitation",
  "invitationRegistrationMessage": "Complete registration to accept the invitation",
  "invitationExpiredTitle": "Invitation expired",
  "invitationExpiredMessage": "The invitation from {{company}} for {{email}} is no longer valid — invitations last 7 days.",
  "invitationRequestRenewal": "Request a new invitation",
  "invitationRenewalRequested": "Request sent — {{company}} was notified to send you a new invitation.",
  "invitationRenewalError": "Could not request a new invitation. Please try again.",
  "onboardingWelcomeTitle": "Welcome to our app!",
  "onboardingWelcomeDescription": "Let's set up some important information before you begin. This will help us personalize your experience.",
  "continue": "Continue",
  "finish": "Finish",
  "retry": "Retry",
  "errorAddingVehicle": "Error adding vehicle.",
  "loadingVehicleInfo": "Loading vehicle information...",
  "vehicleDataFound": "We found your vehicle information:",
  "edit": "Edit",
  "vehicleFormIntro": "Please provide your vehicle information:",
  "licensePlateError": "Invalid format. Use XX-XX-XX (letters and numbers)",
  "permissionsTitle": "App Permissions",
  "permissionsDescription": "To provide the best experience, we need the following permissions:",
  "notificationsPermission": "Notifications",
  "notificationsPermissionMessage": "To receive notifications, you need to enable this permission in your device settings.",
  "notificationsPermissionTitle": "Notifications",
  "notificationsPermissionDescription": "To receive alerts and important information",
  "locationPermission": "Location",
  "locationPermissionMessage": "To use your current location, you need to enable this permission in your device settings.",
  "locationForegroundPermissionTitle": "Location (Foreground)",
  "locationForegroundPermissionDescription": "To show your current location on the map",
  "locationBackgroundError": "Permission required",
  "locationBackgroundErrorMessage": "You need to enable foreground location before enabling background location.",
  "backgroundLocationPermission": "Location (Background)",
  "backgroundLocationPermissionMessage": "To use your location in the background, you need to enable this permission in your device settings. Be sure to select 'Allow all the time' for the app to function correctly.",
  "employmentTitle": "Employment Information",
  "loadingEmploymentInfo": "Loading employment information...",
  "employmentDataFound": "We found your employment information:",
  "employmentFormIntro": "Please provide your employment information:",
  "nipcError": "NIPC must contain 9 digits",
  "companyNipc": "Company NIPC",
  "invitations": "Invitations",
  "driverActive": "Driver already active.",
  "driverInactive": "Driver has an inactive employment.",
  "invitePending": "Invitation pending.",
  "changePaymentMethod": {
    "title": "Update Payment Method",
    "description": "You will be prompted to enter your new payment method details.",
    "continue": "Continue",
    "update": "Update Payment Method",
    "processing": "Processing...",
    "success": "Success",
    "error": "Error",
    "paymentMethodUpdated": "Payment method updated successfully",
    "paymentMethodError": "Failed to update payment method",
    "paymentCancelled": "Payment cancelled",
    "webPaymentError": "Failed to complete payment"
  },
  "manageInStripe": "Manage in Stripe",
  "locationRequiredGeneric": "Location is required. Your location was not shared.",
  "manualLocationPrompt": "Alternatively, enter your location below (address, city, or place).",
  "manualLocationLabel": "Your location (address)",
  "locationNotFound": "Could not find that location.",
  "tryAllowLocation": "Try to allow location again",
  "errors": {
    "errorLoadingData": "Error loading data",
    "errorLoadingDataMessage": "There was a problem loading your data. Please try again.",
    "reloadPage": "Reload Page"
  },
  "purchase": {
    "success": {
      "title": "🎉 Purchase Successful!",
      "messageNew": "Your GPS licenses have been successfully purchased!",
      "messageUpdated": "Your GPS licenses have been successfully updated!",
      "licenses": "Licenses Purchased:",
      "gpsLicenses": "GPS Licenses",
      "ready": "You can now assign these licenses to your drivers and vehicles.",
      "close": "Got it!"
    }
  },
  "licenseType": {
    "selectType": "Select type...",
    "tvde": "TVDE Operator",
    "taxi": "Taxi",
    "lightGoods": "Light goods vehicles",
    "roadTransport": "Road Transport (Without Tachograph)",
    "other": "Other"
  },
  "languages": {
    "english": "🇬🇧 English",
    "portuguese": "🇵🇹 Português",
    "portugueseBR": "🇧🇷 Português (BR)"
  },
  "notifications.stopDriveButton": "Stop Driving",
  "notifications.cancelButton": "Cancel",
  "notifications.activeTracking": "Active Tracking",
  "notifications.locationBeingMonitored": "Your location is being monitored.",
  "notifications.attention": "Attention",
  "notifications.movementDetectedBody": "You are moving but not in driving mode. Please start driving mode.",
  "notifications.stationaryDetectedBody": "You have been stationary for more than {{minutes}} minutes. Consider stopping driving.",
  "notifications.drivingStatus": "Driving Status",
  "notifications.driving": "Driving",
  "notifications.activeSession": "Active Session",
  "notifications.tapToChange": "Tap to change driving state",
  "notifications.startDrivingButton": "Start Driving",
  "notifications.stopDrivingButton": "Stop Driving",
  "notifications": {
    "activeSession": "Active Session",
    "activeTracking": "Active Tracking",
    "attention": "Attention",
    "cancelButton": "Cancel",
    "driving": "Driving",
    "drivingStatus": "Driving Status",
    "locationBeingMonitored": "Your location is being monitored.",
    "movementDetectedBody": "You are moving but not in driving mode. Please start driving mode.",
    "startDrivingButton": "Start Driving",
    "stationaryDetectedBody": "You have been stationary for more than {{minutes}} minutes. Consider stopping driving.",
    "stopDriveButton": "Stop Driving",
    "stopDrivingButton": "Stop Driving",
    "tapToChange": "Tap to change driving state"
  },
  "assign": "Assign",
  "back": "Back",
  "companyInformation": "Company Information",
  "companyPhone": "Company Phone (Optional)",
  "completePurchase": "Complete Purchase",
  "continueToPayment": "Continue to Payment",
  "continueToTrial": "Start Trial",
  "driverButton": "Driver",
  "driverDetails": "Driver Details",
  "errorCancelingInvitation": "Error canceling invitation",
  "errorFetchingInvitations": "Error loading invitations",
  "errorOpeningPortal": "Error opening payment portal",
  "errorResendingInvitation": "Error resending invitation",
  "expired": "Expired",
  "expiresToday": "Expires today",
  "expiresTomorrow": "Expires tomorrow",
  "invitationsPending": "pending",
  "loadingInvitations": "Loading invitations...",
  "manageSubscription": "Manage Subscription",
  "myVehicles": {
    "addFirstVehicle": "Add My First Vehicle",
    "addVehicle": "Add Vehicle",
    "confirmUnassign": "Are you sure you want to remove vehicle {{plate}} from your fleet?",
    "editVehicleInfo": "Edit Vehicle",
    "emptyMessage": "Add your first vehicle to start recording your trips",
    "emptyTitle": "No vehicles yet",
    "menu": "My Vehicles",
    "noDetails": "No details",
    "title": "My Vehicles",
    "tooltipMessage": "Most drivers use just one vehicle, but you can add more if needed",
    "tooltipTitle": "About multiple vehicles",
    "unassignTitle": "Remove Vehicle"
  },
  "next": "Next",
  "noInvitations": "No pending invitations.",
  "okButton": "OK",
  "ownerButton": "Fleet Owner",
  "paymentDescription": "You will be redirected to our secure payment page to complete the purchase.",
  "paymentError": "An error occurred. Please try again.",
  "paymentModalTitle": "Complete Purchase",
  "registerChoiceTitle": "Register",
  "registerDriverTitle": "Driver Registration",
  "registerOwnerTitle": "Register as Fleet Owner",
  "registerTitle": "Register",
  "registrationSuccessMessage": "Please confirm your email to complete registration.",
  "registrationSuccessTitle": "Registered successfully!",
  "resend": "Resend",
  "statusLabels": {
    "pending": "Pending"
  },
  "trialDescription": "You will be redirected to our secure payment page to start the trial period.",
  "vehicleModal": {
    "registrationNumberImmutable": "The registration number cannot be changed. For a different registration, create a new vehicle."
  },
  "vehicleSelection": {
    "confirm": "Confirm",
    "subtitle": "Choose the vehicle you will use for this work session",
    "title": "Select Vehicle"
  },
  "invitationRecipient": "Receiving account: {{email}}",
  "invitationPayerCompany": "Payer: company",
  "invitationPayerSelf": "Payer: driver",
  "invitationPayerUnknown": "Payer not confirmed. Ask the company before accepting.",
  "invitationCompanyConsent": "Accepting changes your work company to the company shown in this invitation. Your open session and historical records retain their original attribution.",
  "invitationConfirm": "Accept invitation",
  "invitationIdentityChanged": "The account or invitation terms changed. Open the invitation again to confirm.",
  "invitationAcceptanceFailed": "Unable to accept the invitation. Try again or contact support.",
  "drivingLimit": {
    "warningTitle": "Driving limit approaching",
    "warningBody": "{{minutes}} min left before reaching {{hours}} h of driving in the last 24 h if you keep driving.",
    "reachedTitle": "Driving limit reached",
    "reachedBody": "You have reached {{hours}} h of driving in the last 24 h. Stop safely and take a break.",
    "noticeWarning": "{{remaining}} left until the {{hours}} h driving limit in 24 h.",
    "noticeReached": "{{hours}} h driving limit in 24 h reached.",
    "noticeReachedUntil": "{{hours}} h driving limit in 24 h reached. Back under the limit from {{time}}."
  },
  "workTime": {
    "states": {
      "resting": "Session inactive",
      "available": "Session active",
      "driving": "Driving"
    },
    "since": "since {{time}}",
    "timerA11y": "{{state}} for {{duration}}",
    "limits": {
      "title": "Driving limits",
      "subtitle": "Reference limits: warnings only, nothing is blocked.",
      "viewAll": "View limits",
      "close": "Close",
      "usedOf": "{{used}} of {{limit}}",
      "remaining": "{{remaining}} left",
      "noData": "No recent record",
      "rolling24h": {
        "title": "Driving in the last 24 h",
        "short": "24 h"
      },
      "week": {
        "title": "Driving this week",
        "short": "Week",
        "range": "Monday to Sunday",
        "reached": "Weekly limit reached. Any further driving goes over 60 h."
      },
      "fourMonth": {
        "title": "4-month driving average",
        "short": "4 months",
        "value": "{{avg}} h per week (limit {{limit}} h)",
        "available": "To keep the average under {{limit}} h: up to {{hours}} h of driving this week.",
        "window": "Average of the last {{weeks}} weeks, this one included.",
        "over": "Average above {{limit}} h. Drive fewer hours in the coming weeks.",
        "partial": "Less than 17 weeks of records: weeks with no records count as 0 h.",
        "above": "Above the limit",
        "summaryValue": "avg {{avg}} h / {{limit}} h"
      },
      "levels": {
        "ok": "Within the limit",
        "warning": "Heads up",
        "critical": "Almost at the limit",
        "reached": "Limit reached",
        "unknown": "No record"
      },
      "weekWarning": "{{used}} of driving this week. Limit: {{limit}}.",
      "fourMonthWarning": "4-month driving average: {{avg}} h per week. Limit: {{limit}} h.",
      "howWeCount": {
        "title": "How we count",
        "driving": "Only time in «Driving» counts, across all platforms.",
        "periods": "24 h: the last 24 hours. Week: Monday to Sunday. 4 months: weekly average over the last 17 weeks.",
        "notCounted": "An active session without driving and a closed session do not count. Unrecorded time never counts as rest.",
        "disclaimer": "These are reference limits, for warnings only. They show the driving time recorded in the app and are not an official record of hours."
      },
      "summaryValue": "{{used}} / {{limit}}"
    },
    "notifications": {
      "ongoingBody": "Since {{time}}.",
      "weekWarningTitle": "Driving this week: {{used}} h of {{limit}} h",
      "weekWarningBody": "{{remaining}} h of driving left before the weekly limit.",
      "fourMonthWarningTitle": "4-month driving average close to the limit",
      "fourMonthWarningBody": "Average of {{avg}} h per week. Limit: {{limit}} h."
    }
  },
  "mapLoading": {
    "title": "Preparing your live map",
    "subtitle": "Loading location view and controls before the route appears.",
    "loading": "Loading map…",
    "errorTitle": "The map couldn't load",
    "errorMessage": "Check your connection and try again. Session controls keep working.",
    "retry": "Try again"
  }
}
